import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import {
  AdminCosmeticDataSourceService,
  AdminCosmeticDetailsForm,
} from '@web/shared/module/cosmetic';
import { once } from '@web/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminCosmeticDetailsFormComponent } from '../admin-cosmetic-details-form/admin-cosmetic-details-form.component';

@Component({
  selector: 'app-admin-cosmetic-create',
  imports: [AlertsComponent, AdminCosmeticDetailsFormComponent],
  templateUrl: './admin-cosmetic-create.component.html',
  styleUrl: './admin-cosmetic-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminCosmeticCreateComponent {
  private readonly cosmeticDataSource = inject(AdminCosmeticDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminCosmeticDetailsForm): void {
    this.cosmeticDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
